// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal CSS */

.addEditNmscModal {
    max-width: 50rem !important;
}

.addEditNmscModal-toyota .modal-dialog, .addEditNmscModal-toyota .modal-content {
    border-radius: 24px !important;
    border: 1px solid #e50000 !important;
}

.addEditNmscModal-lexus .modal-dialog, .addEditNmscModal-lexus .modal-content {
    border-radius: 24px !important;
    border: 1px solid #252525 !important;
}

.addEditNmscModal-toyota .modal-header {
    background-color: #e50000;
    border-top-left-radius: 20px !important;
    border-top-right-radius: 20px !important;
    padding: 0.5rem !important;
}

.addEditNmscModal-lexus .modal-header {
    background-color: #252525;
    border-top-left-radius: 20px !important;
    border-top-right-radius: 20px !important;
    padding: 0.5rem !important;
}

.modal-title {
    color: white;
    font-size: 1.0rem !important;
    padding-left: 0.5rem;
}

.modal-header .close {
    color: white;
    padding: 1.5rem !important;
    margin: -1.3rem -1rem -2rem auto !important;
}

.redFont {
    color: #e50000;
}



.addEditNmscModal .css-10nd86i svg {
    color: #e50000;
}

.addEditNmscModal .css-10nd86i .css-1492t68 {
    text-indent: -9999px;
}

.addEditNmscModal .css-va7pk8 {
    color: #595d60 !important;
}

.addEditNmscModal .modal-body {
    font-size: 0.81rem;
    color: #595d60;
    padding: 0px !important;
}

/* .addEditNmscModal textarea.form-control {
    height: calc(2.25rem + 2px);
} */

.addEditNmscModal .modal-content {
    width: 42rem;
}

.addEditNmscModal li {
    float: left !important;
    vertical-align: middle;
    width: 100% !important;
}

.addEditNmscModal li>.nav-link {
    border: none !important;
    text-align: right;
}

.addEditNmscModal-toyota li>.nav-link.active {
    -background-color: red;
    color: #e50000;
}

.addEditNmscModal-lexus li>.nav-link.active {
    -background-color: #252525;
    color: #252525;
}

.addEditNmscModal-toyota li>.nav-link:focus, .addEditNmscModal-toyota li>.nav-link:hover {
    color: #e50000 !important;
}

.addEditNmscModal-lexus li>.nav-link:focus, .addEditNmscModal-lexus li>.nav-link:hover {
    color: #252525 !important;
}

.createKPITabs ul {
    float: left;
}

.createKPITabs .tab-content {
    background: none;
    border: solid 1px #d8d8d8;
    border-radius: 0px;
    width: 28rem;
    margin-left: 11rem;
    padding-bottom: 1rem;
}

.react-bootstrap-table td.react-bs-table-no-data {
    width: 100% !important;
}

.nav-tabs>li:first-child>a {
    border-top-left-radius: 1.25rem;
}

.nav-tabs>li:last-child>a {
    border-top-right-radius: 0rem!important;
}


.addEditNmscModal .col-md-3 {
    max-width: 30%;
}

.createKPITabs label {
    margin: 8px 0 0 0;
}

.addkpi_modal_unit{
    width: 50%;
}`, "",{"version":3,"sources":["webpack://./src/components/nmscModal/index.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd;IACI,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,0BAA0B;IAC1B,2CAA2C;AAC/C;;AAEA;IACI,cAAc;AAClB;;;;AAIA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,uBAAuB;AAC3B;;AAEA;;GAEG;;AAEH;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,uCAAuC;AAC3C;;;AAGA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd","sourcesContent":["/* Modal CSS */\n\n.addEditNmscModal {\n    max-width: 50rem !important;\n}\n\n.addEditNmscModal-toyota .modal-dialog, .addEditNmscModal-toyota .modal-content {\n    border-radius: 24px !important;\n    border: 1px solid #e50000 !important;\n}\n\n.addEditNmscModal-lexus .modal-dialog, .addEditNmscModal-lexus .modal-content {\n    border-radius: 24px !important;\n    border: 1px solid #252525 !important;\n}\n\n.addEditNmscModal-toyota .modal-header {\n    background-color: #e50000;\n    border-top-left-radius: 20px !important;\n    border-top-right-radius: 20px !important;\n    padding: 0.5rem !important;\n}\n\n.addEditNmscModal-lexus .modal-header {\n    background-color: #252525;\n    border-top-left-radius: 20px !important;\n    border-top-right-radius: 20px !important;\n    padding: 0.5rem !important;\n}\n\n.modal-title {\n    color: white;\n    font-size: 1.0rem !important;\n    padding-left: 0.5rem;\n}\n\n.modal-header .close {\n    color: white;\n    padding: 1.5rem !important;\n    margin: -1.3rem -1rem -2rem auto !important;\n}\n\n.redFont {\n    color: #e50000;\n}\n\n\n\n.addEditNmscModal .css-10nd86i svg {\n    color: #e50000;\n}\n\n.addEditNmscModal .css-10nd86i .css-1492t68 {\n    text-indent: -9999px;\n}\n\n.addEditNmscModal .css-va7pk8 {\n    color: #595d60 !important;\n}\n\n.addEditNmscModal .modal-body {\n    font-size: 0.81rem;\n    color: #595d60;\n    padding: 0px !important;\n}\n\n/* .addEditNmscModal textarea.form-control {\n    height: calc(2.25rem + 2px);\n} */\n\n.addEditNmscModal .modal-content {\n    width: 42rem;\n}\n\n.addEditNmscModal li {\n    float: left !important;\n    vertical-align: middle;\n    width: 100% !important;\n}\n\n.addEditNmscModal li>.nav-link {\n    border: none !important;\n    text-align: right;\n}\n\n.addEditNmscModal-toyota li>.nav-link.active {\n    -background-color: red;\n    color: #e50000;\n}\n\n.addEditNmscModal-lexus li>.nav-link.active {\n    -background-color: #252525;\n    color: #252525;\n}\n\n.addEditNmscModal-toyota li>.nav-link:focus, .addEditNmscModal-toyota li>.nav-link:hover {\n    color: #e50000 !important;\n}\n\n.addEditNmscModal-lexus li>.nav-link:focus, .addEditNmscModal-lexus li>.nav-link:hover {\n    color: #252525 !important;\n}\n\n.createKPITabs ul {\n    float: left;\n}\n\n.createKPITabs .tab-content {\n    background: none;\n    border: solid 1px #d8d8d8;\n    border-radius: 0px;\n    width: 28rem;\n    margin-left: 11rem;\n    padding-bottom: 1rem;\n}\n\n.react-bootstrap-table td.react-bs-table-no-data {\n    width: 100% !important;\n}\n\n.nav-tabs>li:first-child>a {\n    border-top-left-radius: 1.25rem;\n}\n\n.nav-tabs>li:last-child>a {\n    border-top-right-radius: 0rem!important;\n}\n\n\n.addEditNmscModal .col-md-3 {\n    max-width: 30%;\n}\n\n.createKPITabs label {\n    margin: 8px 0 0 0;\n}\n\n.addkpi_modal_unit{\n    width: 50%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
